import { useState, useRef, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isolateStaff } from '../../../slices/staffSlice';
import { HugeiconsIcon } from '@hugeicons/react';
import { MoreHorizontalCircle01Icon, EyeIcon } from '@hugeicons/core-free-icons';

function Member({ item }) {

    const dispatch = useDispatch();
    const [dropOpen, setDropOpen] = useState(false);
    const [dropPos, setDropPos] = useState({ top: 0, left: 0 });
    const btnRef = useRef(null);
    const panelRef = useRef(null);

    const close = useCallback(() => setDropOpen(false), []);

    useEffect(() => {
        if (!dropOpen) return;
        const handler = (e) => {
            if (
                panelRef.current && !panelRef.current.contains(e.target) &&
                btnRef.current && !btnRef.current.contains(e.target)
            ) close();
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [dropOpen, close]);

    useEffect(() => {
        if (!dropOpen) return;
        window.addEventListener("scroll", close, true);
        return () => window.removeEventListener("scroll", close, true);
    }, [dropOpen, close]);

    const openDrop = () => {
        const rect = btnRef.current.getBoundingClientRect();
        const panelW = 140;
        const left = rect.right - panelW < 0 ? rect.left : rect.right - panelW;
        setDropPos({ top: rect.bottom + 6, left });
        setDropOpen(o => !o);
    };

    return (
        <>
        <tr className="hover:bg-gray-50/40 dark:hover:bg-gray-700/30 transition-colors text-sm">
            <td className="px-5 py-3.5 font-medium text-gray-800 dark:text-gray-100">
                {item?.otherNames} {item?.surname}
            </td>
            <td className="px-5 py-3.5 text-gray-500 dark:text-gray-400">{item?.email}</td>
            <td className="px-5 py-3.5 text-gray-500 dark:text-gray-400">{item?.phone}</td>
            <td className="px-5 py-3.5">
                {item?.isActive ? (
                    <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-100 rounded-full">
                        Active
                    </span>
                ) : (
                    <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium bg-red-50 text-red-600 border border-red-100 rounded-full">
                        Inactive
                    </span>
                )}
            </td>
            <td className="px-5 py-3.5">
                <button
                    ref={btnRef}
                    onClick={openDrop}
                    className="flex items-center justify-center w-8 h-8 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-gray-200 transition-colors"
                >
                    <HugeiconsIcon icon={MoreHorizontalCircle01Icon} size={20} />
                </button>
            </td>
        </tr>

        {dropOpen && (
            <tr style={{ display: 'contents' }}>
                <td style={{ display: 'contents' }}>
                    <div
                        ref={panelRef}
                        style={{ position: 'fixed', top: dropPos.top, left: dropPos.left, zIndex: 9999, width: 140 }}
                        className="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 py-1.5 overflow-hidden"
                    >
                        <Link
                            to="/admin/staff/edit"
                            onClick={() => { dispatch(isolateStaff(item?._id)); close(); }}
                            className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                        >
                            <HugeiconsIcon icon={EyeIcon} size={15} className="text-gray-400 shrink-0" />
                            View / Edit
                        </Link>
                    </div>
                </td>
            </tr>
        )}
        </>
    );
}

export default Member;
